export default {
    queued: { status: window.i18n.__('En attente de traitement'), order: 1 },
    processing: { status: window.i18n.__('En cours de traitement'), order: 2 },
    processed: { status: window.i18n.__('Traité'), order: 3 },
    cancelled: { status: window.i18n.__('Annulé'), order: 2 },
    reverting: { status: window.i18n.__('Annulation en cours'), order: 4 },
    reverted: { status: window.i18n.__('Changements annulés'), order: 5 },
    failed: { status: window.i18n.__('Erreur système'), order: 6 },
};
